<template>
  <div class="container">
    <div class="select-skill-skillname">
      {{ selectedSkill.name }}
    </div>
    <div
      class="select-skill-tagged"
    >
      {{ selectedSkill.tagged ? "TAGGED" : "" }}
    </div>
    <div>
      <GenericButton
        :is-disabled="getDisabledButton('-')"
        variant="minus"
        width="26px"
        height="26px"
        text="-"
        @click="modifySkill('-')"
      />
      <div
        class="select-skill-skillpercent"
      >
        {{
          selectedSkill.value ? selectedSkill.value + "%" : ""
        }}
      </div>
      <GenericButton
        :is-disabled="getDisabledButton('+')"
        variant="plus"
        width="26px"
        height="26px"
        text="+"
        @click="modifySkill('+')"
      />
      <GenericProgressBar
        :progress="selectedSkill.skillValue"
        :max="selectedSkill.skillMaxValue"
      />
      <GenericTabs
        :tabs="tabs"
        variant="group"
        @activeTab="handleActiveTab"
      />
    </div>
  </div>
</template>
<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import getThresholdData from '@/utils/getSkillThreshold'
import GenericButton from "../shared/GenericButton.vue";
import GenericTabs from "../shared/GenericTabs.vue";
import GenericProgressBar from "../shared/GenericProgressBar.vue";

export default {
    name: "SelectSkill",
    setup() {
        const store = useStore();
        const multiplier = ref(1);
        const handleActiveTab = (tab) => {
            multiplier.value = tab.value;
        };
        const getProgressBarText = (skill, progress) => {
          const activeStyle = store.state.ui.progressBarStyle.activeStyle;
          const progressBarStyles = {
            default: `${skill.value} / ${skill.maxValue} ( ${progress}% )`,
            currentAndMax: `${skill.value} / ${skill.maxValue}`,
            percent: `${progress}%`,
            none: '',
          }
          return progressBarStyles[activeStyle];
        }
        const selectedSkill = computed(() => {
          const skillKey = store.state.ui.selectedSkill || store.state.build.info.Skills[0];
          const skill = store.state.build.Skills[skillKey];
          const skillProgress = Math.floor((skill.value / skill.maxValue) * 100);
          return {
            ...skill,
            key: skillKey,
            progress: skillProgress,
            progressStyle:  `width: ${skillProgress}%;`,
            progressText: getProgressBarText(skill, skillProgress),
            cost: getThresholdData(skill.value).cost,
            skillMaxValue: skill.maxValue,
            skillValue: skill.value
          };
        })

        const modifySkill = (modifier) => {
            const data = {
                skill: selectedSkill.value.key,
                modifier,
                multiplier: multiplier.value,
            };
            store.dispatch('handleIncomingCommand', {
                command: 'modifySkill',
                data: data
            });
        };
        const changeProgressBarStyle = () => {
            store.dispatch('handleIncomingCommand', {
                command: 'changeProgressBarStyle',
                data: null
            });
        };
        const getDisabledButton = (modifier) => {
          const skill = selectedSkill.value;

          if (modifier === '-') {
              return store.state.build.Skills[skill.key].stepSkillValue === 0;
          }
          else if (modifier === '+') {
              return store.state.build.info.availableSkillPoints < skill.cost || skill.value >= skill.maxValue;
          }
        };
        const tabs = computed(() => {
          return [
            {
              name: 'x1',
              value: 1,
              selected: multiplier.value === 1,
            },
            {
              name: 'x5',
              value: 5,
              selected: multiplier.value === 5,
            },
            {
              name: 'x10',
              value: 10,
              selected: multiplier.value === 10,
            },
            {
              name: 'x100',
              value: 100,
              selected: multiplier.value === 100,
            },
          ]
        })

        return {
            state: store.state,
            multiplier,
            handleActiveTab,
            modifySkill,
            changeProgressBarStyle,
            getDisabledButton,
            tabs,
            selectedSkill
        };
    },
    components: { GenericButton, GenericTabs, GenericProgressBar }
};
</script>
<style scoped>
.container {
  position: relative;
  display: flex;
  flex-direction: column;
}
.select-skill-skillname {
  display: inline-block;
  width: 100%;
  height: 14px;
  font-size: 16px;
  text-shadow: 2px 2px 3px rgb(44, 43, 43);
  margin-bottom: 3px;
  color: #f9ffb6;
}
.select-skill-tagged {
  font-size: 12px;
  color: var(--text-tagged);
  max-height: 12px;
  min-height: 12px;
  margin-bottom: 3px;
}
.select-skill-skillpercent {
  display: inline-block;
  color: white;
  width: 60px;
  font-size: 22px;
  font-family: var(--font-family-gothic);
  -webkit-text-stroke: var(--text-stroke-black);
}
</style>